module.exports = __webpack_public_path__ + "static/img/menage8.5d4bf6d2.png";